<template>
  <div></div>
</template>
<script>
import swal from "sweetalert2";

export default {
  data: () => ({}),
  async created() {
    swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false,
      onOpen: () => {
        swal.showLoading();
      },
    });

    await this.$store.dispatch("handleCallback");
  },
};
</script>

<style scoped>
.w-38px {
  width: 38px;
}
.h-38px {
  height: 38px;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) /* #000000 */;
}
.rounded-12px {
  border-radius: 12px;
}
.border-1px {
  border-width: 1px;
  border-style: solid;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) /* #000000 */;
}
.gap-12px {
  gap: 12px;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity)) /* #000000 */;
}
</style>
